const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const getAuthToken = (): string | null => {
  return localStorage.getItem('authToken');
};

const apiRequest = async (
  endpoint: string,
  options: RequestInit = {}
): Promise<any> => {
  const token = getAuthToken();
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(options.headers as HeadersInit),
  };

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'API request failed');
  }

  return data;
};

export const copyTradeApi = {
  getBots: async () => {
    const response = await apiRequest('/copy-trade-bots?limit=100');
    return response.bots || [];
  },

  getConfigs: async () => {
    const response = await apiRequest('/copy-trade/configs');
    return response.configs;
  },

  getAccounts: async () => {
    const response = await apiRequest('/copy-trade/accounts');
    return response.accounts.map((acc: any) => ({
      ...acc,
      copyTradeImage: acc.copyTradeImage || '',
    }));
  },

  linkAccount: async (botId: string, uid: string) => {
    const response = await apiRequest('/copy-trade/accounts', {
      method: 'POST',
      body: JSON.stringify({ botId, uid }),
    });
    return response.account;
  },

  deleteAccount: async (accountId: string) => {
    return apiRequest(`/copy-trade/accounts/${accountId}`, {
      method: 'DELETE',
    });
  },
};

